import { call, all } from 'redux-saga/effects';

import * as pageStateService from '../page-state/page-state.saga-services';
import * as pageInitializerService from '../page.initializer.saga-service';
import { ICurrentAgendaIndex } from '../page-storage/agenda-items/agenda-items.types';
import { annualsSelectors } from '../../resource/annuals/annuals.selectors';
import { select } from '../../../utils/selector.utils';
import { IAnnual } from '../../resource/annuals/annuals.types';
import * as annualsService from '../../resource/annuals/annuals.saga-service';

export function* initalLiveMeetingPage(meetingParams: ICurrentAgendaIndex) {
  if (!meetingParams.meetingId) {
    return;
  }
  yield call(pageStateService.initPage, 'liveMeeting');

  if (!((yield call(pageInitializerService.initPage)) as boolean)) {
    const isAnnualsFetched = !!((yield select(annualsSelectors.selectResourceList)) as IAnnual[]).length;

    const parallelCalls: ReturnType<typeof call>[] = [];
    if (!isAnnualsFetched) {
      parallelCalls.push(call(annualsService.getAnnuals));
    }
    if (parallelCalls.length > 0) {
      yield all(parallelCalls);
    }

    //yield call(meetingService.putMeetings);
    // yield call(agendaService.moveToNextAgenda, meetingParams);
    //yield call(agendaService.setupAgendaItemsForMeeting, meetingParams.meetingId);
    //yield call(taskService.setupTasksForMeeting, meetingParams.meetingId);
    //yield call(kpiService.setupKpi, meetingParams.meetingId);
    //yield call(sessionService.setupSessions, { id: meetingParams.meetingId });
  }

  yield call(pageStateService.completedInit, 'liveMeeting');
}
